import { useQuery } from '@tanstack/react-query';

import { getOwnDebitCards, getRelatedDebitCards } from '@/react-query/services/debit-card';

import { useSession } from '@components/app/Session';
import { Card } from '@generated-types';

export const useMyDebitCards = ({ enabled = true }: { enabled?: boolean } = {}) => {
    const session = useSession();
    return useQuery<Card[]>({
        queryKey: ['myDebitCards'],
        queryFn: getOwnDebitCards,
        enabled: enabled && !!session.debitProfile,
    });
};

export const useRelatedDebitCards = ({ enabled = true }: { enabled?: boolean } = {}) => {
    const session = useSession();
    return useQuery<Card[]>({
        queryKey: ['relatedDebitCards'],
        queryFn: getRelatedDebitCards,
        enabled: enabled && !!session.debitProfile,
    });
};
